export default function reduceImage(
  e: File,
  w: number,
  h: number
): Promise<HTMLCanvasElement> {
  let x,
    y = 0,
    sx,
    sy,
    ssx,
    ssy,
    r,
    g,
    b,
    a;

  // const imgFromInput = e.target.files[0];
  const url = URL.createObjectURL(e);

  const img = new Image();

  img.src = url;

  return new Promise((resolve) => {
    img.onload = (e) => {
      const RGB2sRGB = 2.2; // this is an approximation of sRGB
      const sRGB2RGB = 1 / RGB2sRGB;
      const sRGBMax = 255 ** RGB2sRGB;

      const srcW = img.naturalWidth;
      const srcH = img.naturalHeight;
      const srcCan = Object.assign(document.createElement("canvas"), {
        width: srcW,
        height: srcH,
      });
      const sCtx = srcCan.getContext("2d");
      const destCan = Object.assign(document.createElement("canvas"), {
        width: w,
        height: h,
      });
      const dCtx = destCan.getContext("2d");
      sCtx.drawImage(img, 0, 0);
      const srcData = sCtx.getImageData(0, 0, srcW, srcH).data;
      const destData = dCtx.getImageData(0, 0, w, h);

      // Warning if yStep or xStep span less than 2 pixels then there may be
      // banding artifacts in the image
      const xStep = srcW / w,
        yStep = srcH / h;
      if (xStep < 2 || yStep < 2) {
        console.warn("Downsample too low. Should be at least 50%");
      }
      const area = xStep * yStep;
      const sD = srcData,
        dD = destData.data;

      while (y < h) {
        sy = y * yStep;
        x = 0;
        while (x < w) {
          sx = x * xStep;
          const ssyB = sy + yStep;
          const ssxR = sx + xStep;
          r = g = b = a = 0;
          ssy = sy | 0;
          while (ssy < ssyB) {
            const yy1 = ssy + 1;
            const yArea =
              yy1 > ssyB ? ssyB - ssy : ssy < sy ? 1 - (sy - ssy) : 1;
            ssx = sx | 0;
            while (ssx < ssxR) {
              const xx1 = ssx + 1;
              const xArea =
                xx1 > ssxR ? ssxR - ssx : ssx < sx ? 1 - (sx - ssx) : 1;
              const srcContribution = (yArea * xArea) / area;
              const idx = (ssy * srcW + ssx) * 4;
              r += (sD[idx] ** RGB2sRGB / sRGBMax) * srcContribution;
              g += (sD[idx + 1] ** RGB2sRGB / sRGBMax) * srcContribution;
              b += (sD[idx + 2] ** RGB2sRGB / sRGBMax) * srcContribution;
              a += (sD[idx + 3] / 255) * srcContribution;
              ssx += 1;
            }
            ssy += 1;
          }
          const idx = (y * w + x) * 4;
          dD[idx] = (r * sRGBMax) ** sRGB2RGB;
          dD[idx + 1] = (g * sRGBMax) ** sRGB2RGB;
          dD[idx + 2] = (b * sRGBMax) ** sRGB2RGB;
          dD[idx + 3] = a * 255;
          x += 1;
        }
        y += 1;
      }

      dCtx.putImageData(destData, 0, 0);

      resolve(destCan);
      URL.revokeObjectURL(url);
    };
  });
}
